/* MM – Cartes collection : clic sur une couleur = photo + liens + tailles de cette couleur.
   Fonctionne aussi après un filtre ou un tri (la grille est rechargée). */
(function () {
  if (window.mmCardsReady) return;
  window.mmCardsReady = true;

  function getData(card) {
    if (card._mmData) return card._mmData;
    var el = card.querySelector('.mm-card__json');
    try { card._mmData = el ? JSON.parse(el.textContent) : []; } catch (e) { card._mmData = []; }
    return card._mmData;
  }

  function find(list, test) {
    for (var i = 0; i < list.length; i++) { if (test(list[i])) return list[i]; }
    return null;
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.mm-card__swatch') : null;
    if (!sw) return;
    var card = sw.closest('.mm-card');
    if (!card) return;
    e.preventDefault();

    var data = getData(card);
    var ci = parseInt(card.getAttribute('data-ci'), 10);
    var si = parseInt(card.getAttribute('data-si'), 10);
    var color = sw.getAttribute('data-color');
    if (isNaN(ci) || ci < 0 || !data.length) return;

    card.querySelectorAll('.mm-card__swatch').forEach(function (b) {
      var on = b === sw;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var same = data.filter(function (v) { return v.o[ci] === color; });
    if (!same.length) return;
    var first = find(same, function (v) { return v.a; }) || same[0];

    var withImg = find(same, function (v) { return v.i; });
    var img = card.querySelector('.mm-card__img--main');
    if (withImg && img) {
      img.setAttribute('srcset', withImg.s + ' 450w, ' + withImg.i + ' 900w');
      img.setAttribute('src', withImg.i);
    }

    card.querySelectorAll('.mm-card__link').forEach(function (a) { a.setAttribute('href', first.u); });

    var holder = card.closest('[data-soldout]');
    var soldout = holder ? holder.getAttribute('data-soldout') : '';
    if (!isNaN(si) && si >= 0) {
      card.querySelectorAll('.mm-card__size').forEach(function (a) {
        var v = find(same, function (x) { return x.o[si] === a.getAttribute('data-size'); });
        var off = !v || !v.a;
        if (v) a.setAttribute('href', v.u);
        a.classList.toggle('mm-card__size--off', off);
        var sr = a.querySelector('.mm-card__size-sr');
        if (sr) sr.textContent = off && soldout ? ' – ' + soldout : '';
      });
    }
  });
})();
